import { render, staticRenderFns } from "./head-3.vue?vue&type=template&id=1d0dbdf6&scoped=true&lang=pug&"
import script from "./head-3.vue?vue&type=script&lang=js&"
export * from "./head-3.vue?vue&type=script&lang=js&"
import style0 from "./head-3.vue?vue&type=style&index=0&id=1d0dbdf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0dbdf6",
  null
  
)

export default component.exports